// eslint-disable-next-line unicorn/prevent-abbreviations
export default class DevKpathController {
	/* @ngInject */
	/**
	 * @param {any} KformComponents
	 */
	constructor(KformComponents) {
		this.component = { ...KformComponents.components.kpath.settings };
		this.data = {
			options: {
				display: 'breadcrumb',
				mode:    'kpath',
			},
			label: 'My KPATH component',
			required: false,
			disabled: false,
			placeholder: 'My placeholder',
			kpath_kid: undefined,
			kpath: undefined,
			// kpath: [
			// 	{
			// 		kid:  'K_NODE;0001015M030ZABBD5Z',
			// 		name: 'A.1',
			// 	},
			// 	{
			// 		kid:  'K_NODE;0001015M030ZABBD61',
			// 		name: 'IAIN',
			// 		flow: 'down',
			// 	},
			// ],
		};
		this.form = { title: 'Unknown form' };
		this.jsonEditorOptions = {
			mode:    'code',
			modes:   [
				'code',
				'form',
				'text',
				'tree',
				'view',
			],
		};
		this.views = KformComponents.components.kpath.views;

		this.changeValue = (/** @type {any} */ value) => {
			// eslint-disable-next-line no-console
			console.log('changeValue', value);
		};
	}
}
